<template>
  <div class="home">
    <div class="bg_black text_white">
      <div class="ninew bodybox">
        <van-nav-bar
          :title="$t('center.platformInfo')"
          left-arrow
          z-index="9"
          @click-left="$router.push('/PlatformInfo')"
        >
          <van-icon
            name="./static/img/ok.png"
            slot="right"
            @click="createPlatform()"
            style="font-size: 24px"
          />
        </van-nav-bar>
      </div>
    </div>
    <div class="shopList ninew bodybox">
      <van-cell-group>
        <van-field
          v-model="platformInfo.name"
          :label="$t('platform.platname')"
          clearable
          :placeholder="$t('platform.inputPlatName')"
        />
        <!-- 店铺图片 -->
        <van-cell
          :title="$t('platform.platImage')"
          title-style="width: 110px;flex:none;"
        >
          <van-uploader name="image" :after-read="afterRead" style="float:left">
            <van-image v-if="image" width="55" height="55" :src="image" />
            <van-image
              v-else
              width="55"
              height="55"
              fit="contain"
              src="./static/img/add_img.png"
            />
          </van-uploader>
        </van-cell>
        <!-- 二维码图 -->
        <!-- <van-cell
          :title="$t('platform.platCode')"
          title-style="width: 125px;flex:none;"
        >
          <van-uploader name="qrcode" :after-read="afterRead">
            <van-image v-if="qrcode" width="55" height="55" :src="qrcode" />
            <van-image
              v-else
              width="55"
              height="55"
              fit="contain"
              src="./static/img/add_img.png"
            />
          </van-uploader>
        </van-cell>

        <van-field
          v-model="platformInfo.link"
          :label="$t('platform.platLink')"
          clearable
          :placeholder="$t('platform.platInputLink')"
        /> -->
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      image: "",
      qrcode: "",
      platformInfo: {
        name: "",
        image_id: "",
        qrcode_id: "",
        link: ""
      }
    };
  },
  mounted: function() {},
  computed: {},
  methods: {
    afterRead(file, detail) {
      // 此时可以自行将文件上传至服务器
      // console.log(file);
      // console.log(detail.name);
      let formData = new FormData();
      formData.append("type", "shop");
      formData.append("file", file.file);
      this.$axios({
        method: "post",
        url: this.$build + "/api/image",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + sessionStorage.token
        },
        data: formData
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            if (detail.name == "qrcode") {
              this.platformInfo.qrcode_id = res.data.success.image_id;
              this.qrcode = res.data.success.url;
            } else if (detail.name == "image") {
              this.platformInfo.image_id = res.data.success.image_id;
              this.image = res.data.success.url;
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message")
          });
        });
    },
    // 创建平台资料
    createPlatform() {
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/platform/store",
        data: this.platformInfo
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            // this.shops=res.data.data;
            this.$toast({
              type: "success",
              message: res.data.message
            });
            const vm = this;
            setTimeout(function() {
              vm.$router.push("/PlatformInfo");
            }, 1500);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message")
          });
        });
    }
  }
};
</script>
<style>
.addShop .van-grid-item__content {
  padding: 0;
}
.addShop .van-image {
  margin: auto;
}
</style>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-cell-group--inset {
  margin: 0;
}
.home {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}
.shopList {
  padding-top: 20px;
}
/deep/ .van-grid-item__content p {
  font-size: 12px;
  text-align: center;
  margin: 0;
  padding: 0;
}
/deep/ .van-grid-item__content {
  padding: 0;
  border-radius: 5px;
  padding-bottom: 10px;
  align-items: center;
  -webkit-align-items: center;
  justify-content: flex-start;
}
.van-grid-item__content p.shopname {
  font-size: 15px;
}
.shopname1 {
  height: 36px;
  align-items: center;
  display: inline-flex;
}
.shopname {
  line-height: 18px;
  align-items: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.shoptime {
  font-size: 12px;
  color: #d4d4d4;
}
.shoptime span {
  color: rgb(253, 63, 63);
}
.van-image {
  align-items: center;
  -webkit-align-items: center;
}
.van-image__img {
  vertical-align: middle;
}
.shopIcon {
  margin: 10px 0;
}
.shopBj {
  width: 100%;
  border-radius: 5px 5px 0 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/Platform/PlatformInfoAdd.vue